/**
 * @file Exemplo
 * jsdoc Board.js ControlLevel.js  Construtor.js ControlGame.js -d ../../documention
 * @author William Luis Alves Ferreira (git:illiamw)
 * @version 2.0.0
 */

import React from "react";


//Componentes de roteamento
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

/**
 * @param {Null} Null Null
 * @description Classe geradora da função app
 * @constructor
 */


export default function View2(props) {


    function navegaNext( next){
        if ( next !== null) {
            return (
                    <div className="mt-2 mx-2">
                        <Link to={next}>
                            <button type="button" className="button-custom bg-color4 buttonR"><i className="material-icons md-light text-black1 ">arrow_right</i></button>
                        </Link>
                    </div>
            );
        } 
            else
                return (<div className="mt-2 mx-2">
                    <button type="button" className="button-custom bg-gray-light disabled buttonR"><i className="material-icons md-light md-inactive text-gray-dark ">arrow_right</i></button>
                
            </div>)
    }


    function navegaPrev(prev){
        if (prev !== null ) {
            return (
                    <div className="mt-2 mx-2">
                        <Link to={prev}>
                            <button type="button" className="button-custom bg-color4 buttonR"><i className="material-icons md-light text-black1 ">arrow_left</i></button>
                        </Link>
                    </div>
            );
        } 
            else
                return (<div className="mt-2 mx-2">
                    <button type="button" className="button-custom bg-gray-light buttonR"><i className="material-icons md-light md-inactive text-gray-dark ">arrow_left</i></button>
                
            </div>)
    }

    function navega(prev, next){
        if (prev !== null || next !== null) {
            return (
                <div className="h-min-view flex-shrink-1 w-100 text-center  d-flex justify-content-center align-items-end">

                    {navegaPrev(prev)}
                    {navegaNext(next)}
                </div>
            );
        } 
            else
                return (null)
    }

    

    // ROTEAMENTO - colocar controle de estados da aplicação
    return (
        <div className="d-flex container min-vh-100 align-items-center">
            <div className="d-flex flex-column align-items-center w-100 view2">
                <div className="h-min-view flex-shrink-1 w-100 text-center  d-flex justify-content-center align-items-end">

                    <div className="bg-color1 text-white1 dialogoTitle arround-6">
                        <h2 className="m-0 p-2 fw-bolder display-4">{props.titulo}</h2>
                    </div>
                </div>
                <div className="flex-fill w-100  bg-color3 text-center arround-12">
                    {props.conteudo}
                </div>
                {navega(props.prev,props.next)}
            </div>

        </div>
    );
}
